import React from 'react'
import { Dropdown } from "flowbite-react";
import { Button, Typography } from '..';
import { ExternalLinkIcon, HelpIcon } from '../../../theme/icons2';
import { useNavigate } from 'react-router-dom';


const theme = {
    "inlineWrapper": "flex items-center text-sm flex items-center h-full  text-primary-500 font-semibold",
    "floating": {
        "item": {
            "container": "",
            "base": "flex w-full cursor-pointer items-center justify-start px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 focus:bg-bg-primary-50 focus:outline-none",
            "icon": "mr-2 h-4 w-4"
        },
        "base": "z-10 w-fit divide-y p-0 divide-gray-100 rounded shadow focus:outline-none",
    }
}
export const HelpMenu = () => {
    const navigate = useNavigate();

    const options = [
        {
            title: "greytHR Support",
            subTitle: "Track all your greytHR support tickets.",
            url: "/greytHR-support",
            externalURL: false,
            divider:true
        },
        {
            title: "Help Articles",
            subTitle: "Browse help articles and knowledge base.",
            url: "https://admin-help.greythr.com/admin/149153098",
            externalURL: true,
            divider:false
        },
        {
            title: "FAQs",
            subTitle: "Find answers to your queries.",
            url: "https://greythr.freshdesk.com/support/solutions/folders/1060000285423",
            externalURL: true,
            divider:false
        },
        {
            title: "Product and Statutory Updates",
            subTitle: "Check what’s new on greytHR.",
            url: "https://product-updates.greythr.com/en",
            externalURL: true,
            divider:false
        },
        {
            title: "Need help with greytHR PRO ?",
            subTitle: "Raise a ticket for assistance.",
            url: "/your-tickets",
            externalURL: false,
            divider:false
        }
    ]

    const handleClickeMenu = (option) => option?.externalURL ? window.open(option?.url, "_blank") : navigate(option?.url)

    return (<Dropdown 
        renderTrigger={() => <span className='h-fit w-fit flex items-center m-auto'><Button text="" className="p-0 m-auto !h-10 w-10" variant="tertiary" icon={<HelpIcon className="h-10 w-10 p-0 m-0" />} />
        </span>}
        theme={theme}>
        <Dropdown.Header dismissOnClick={true}
            className='cursor-pointer border-0' >
            {!!options?.length && options?.map((option,i) =>
                <React.Fragment key={option?.title}>
                    <Dropdown.Item onClick={() => handleClickeMenu(option)}>
                        <div className='flex flex-col gap-1 w-full'>
                            <div className='flex justify-between items-center'>
                                <Typography variant="base" text={option?.title} className="truncate" />
                                {option?.externalURL && <ExternalLinkIcon />}
                            </div>
                            <Typography variant="sm" text={option?.subTitle} className="truncate text-left" />
                        </div> </Dropdown.Item>
                  {option?.divider&&   <Dropdown.Divider />}
                </React.Fragment>
            )}
        </Dropdown.Header>
    </Dropdown>)
}

